import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getResultRatings = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'code', order: 'ASC' }})
    }

    return filterObjectStore(state.resultRating.resultRatings.entries, filter);
};
